import { Component, Input, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HitOverview, WatchAlert } from '@compumark/order-management-client';

export interface UiHitOverview {
  fieldLabel: string;
  fieldName: string;
  fieldOrder?: number;
  checked: boolean;
}
@Component({
  selector: 'app-adjust-hit-overview',
  templateUrl: './adjust-hit-overview.component.html',
  styleUrls: ['./adjust-hit-overview.component.scss'],
  standalone: false,
})
export class AdjustHitOverviewComponent {
  data = inject<WatchAlert>(MAT_DIALOG_DATA);

  searchText = '';
  @Input() columns: UiHitOverview[] = [];

  constructor() {
    const data = this.data;

    if (!data.hitOverView) {
      data.hitOverView = { enabled: true } as HitOverview;
    }
  }

  toHitOverviewField(columns: UiHitOverview[]): void {
    const toHitOverviewField = columns
      .filter((col) => col.checked)
      .slice()
      .sort((a, b) => (a.fieldOrder ?? 0) - (b.fieldOrder ?? 0))
      .map((col, idx) => ({
        fieldLabel: col.fieldLabel,
        fieldName: col.fieldName,
        fieldOrder: idx + 1,
      }));

    this.data.hitOverView = {
      enabled: true,
      selectedFields: toHitOverviewField,
    };
  }
}
